import backendHttpClient from '../_httpClient/backend.http-client';
import type { CreateSurveyPayload } from './dtos/create.dto';
import type { SubmitSurveyBody, SubmitSurveyPayload } from './dtos/submit.dto';
import type { SurveyRepository } from './repository';
import type { CreateSurveyOutput } from './types/create.type';
import type { SubmitSurveyOutput } from './types/submit.type';

class SurveyService implements SurveyRepository {
  public async create(
    payload: CreateSurveyPayload,
  ): Promise<CreateSurveyOutput> {
    const { data } = await backendHttpClient.post<
      CreateSurveyOutput,
      CreateSurveyPayload
    >({
      path: 'surveys',
      body: payload,
    });

    return data;
  }

  public async submit(
    payload: SubmitSurveyPayload,
  ): Promise<SubmitSurveyOutput> {
    const { data } = await backendHttpClient.patch<
      SubmitSurveyOutput,
      SubmitSurveyBody
    >({
      body: payload.body,
      path: `surveys/${payload.id}/submit`,
    });

    return data;
  }
}

export const surveyService = new SurveyService();
